export enum EntitlementFeatures {
  app_access = 'app_access',
  guide_ayurvedic = 'guide_ayurvedic',
  guide_cortisol = 'guide_cortisol',
  guide_arthritis = 'guide_arthritis',
  ai_coach = 'ai_coach',
  ai_coach_male = 'ai_coach_male',
}

export enum EntitlementSources {
  stripe = 'stripe',
  ad_campaign = 'ad_campaign',
  support = 'support',
  orchestrator = 'orchestrator',
  paddle = 'paddle',
}

export enum SubscriptionStatus {
  ACTIVE = 'shared.consts.active',
  CANCELED = 'shared.consts.canceled',
}

export enum SubscriptionInterval {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Year = 'year',
}

const prefix = '/subscriptions';

export const SubscriptionEndpoints: Record<string, string> = {
  getSubscription: prefix,
  cancelSubscription: prefix,
  getEntitlements: '/entitlements',
} as const;
